module.exports = __webpack_public_path__ + "img/no_submit.bb5b6595.png";